import React, {useEffect, useState} from 'react';
import {
    Card,
    CardBody,
    CardTitle,
} from 'reactstrap';

import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    LIST,
    NO, NO_DATA_FOUND,
    YES
} from "../../../components/i18n/i18n";
import {confirmAlert} from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {setFilter, setTableParams} from "../../../redux/actions/generalActions/listActions";
import {setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {remove, search} from "../../../redux/actions/promo/categoryPromotionActions";
import {connect} from "react-redux";
import CategoryPromotionFrom from "./_form";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";

const CategoryPromotionList = (props) => {

    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps
    const [staticFilter, setStaticFilter] = useState({
        fbDataBase : {  id : null },
        item : {
            code: null,
        }
    })

    useEffect(()=>{
        setStaticFilter({
            ...staticFilter,
            fbDataBase: { id : props.mainProps?.app?.fbDataBase?.id }
        })

    },[props.mainProps?.app?.fbDataBase?.id])


    useEffect(() => {
        if(!staticFilter.fbDataBase.id)
            return;
        if ( filter === undefined || filter === null){
            refreshDataList(pageIndex, pageSize, staticFilter);
            return;
        }
        refreshDataList(pageIndex, pageSize, filter);
    }, [pageIndex, pageSize, filter, staticFilter]);

    const refreshDataList =  (_pageIndex, _pageSize, _filter) => props.search(_pageIndex, _pageSize, _filter)

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        props.remove(data.id)
    }

    const editItem = (data) => {
        props.setForm(true, false, false);
        props.setItem(data);
        ModalFormContainer(CategoryPromotionFrom, {data: data, Form: CategoryPromotionFrom})
    }

    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
                <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
            </div>
        );
    }

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'uid',
        text: 'uid'
    }, {
        dataField: 'code',
        text: 'Código'
    }, {
        dataField: 'description',
        text: 'Descripción'
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '150px'},
        formatter: actionsFormatter
    }];

    return (
        <div>
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>{LIST}
                </CardTitle>
                <CardBody className="">
                    <BootstrapTable
                        striped hover
                        tableHeaderClass='mb-0'
                        remote
                        keyField="id"
                        data={listDomainObjects || []}
                        columns={columns}
                        noDataIndication={NO_DATA_FOUND}
                        pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                        onTableChange={handleTableChange}
                    />
                </CardBody>
            </Card>
        </div>
    )
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    search,
    remove,
})
export default connect(mapStateToProps, mapActionsToProps)(CategoryPromotionList)
